const styles = theme => ({
  checkboxContainer: {
    '& .MuiFormControlLabel-label': {
      fontWeight: 500,
      fontSize: '16px',
      color: theme.palette.primary.main,
    },
  },
  checkbox: {
    color: theme.palette.primary.lightADGMGreen,
  },
  checked: {
    color: theme.palette.primary.lightADGMGreen + ' !important',
  },

  '@media (max-width: 645px)': {
    checkboxContainer: {
      '& .MuiFormControlLabel-label': {
        fontSize: '12px',
      },
    },
  },
  fieldsetradio: {
    '& .MuiCheckbox-colorSecondary.Mui-checked': {
      color: theme.palette.primary.main,
    },
  },
});

export default styles;
